import type {CommentAuthorAssociation} from '@github-ui/commenting/IssueCommentHeader.graphql'
import type {ReactionViewerGroup} from '@github-ui/reaction-viewer/ReactionGroupsUtils'
import type {SafeHTMLString} from '@github-ui/safe-html'
import type {Repository} from './issue-comments'
import type {LegacyTeamReviewer} from './review-requests'

export type ReviewSummaryState = 'COMMENTED' | 'APPROVED' | 'CHANGES_REQUESTED' | 'DISMISSED'
export const reviewSummaryStateLabels: Record<ReviewSummaryState, string> = {
  COMMENTED: 'commented',
  APPROVED: 'approved',
  CHANGES_REQUESTED: 'requested changes',
  DISMISSED: 'dismissed',
}
export type ReviewSummary = {
  id: string
  authorAssociation: CommentAuthorAssociation
  authorAvatarUrl: string | null
  authorLogin: string
  body: string
  bodyHtml: SafeHTMLString
  isHidden: boolean
  minimizedReason: string | null
  onBehalfOfTeams: LegacyTeamReviewer[]
  reactionGroups: ReactionViewerGroup[]
  repository: Repository
  state: ReviewSummaryState
  submittedAt: string
  url: string
  viewerCanReact: boolean
}

export type ReviewSummariesPayload = ReviewSummary[]
